// extracted by mini-css-extract-plugin
module.exports = {"inputNumber":"LotUpdateForm_inputNumber__37dUB"};